import { Pipe, PipeTransform } from '@angular/core';
import { OrganisationDto } from '@careapp-group/ng-sdk';

@Pipe({
    name: 'organisationSortPipe',
    pure: true,
    standalone: false
})
// Alphabetical sort of organisation entities.
export class OrganisationSortPipe implements PipeTransform {
  transform(organisations: { key: string; value: OrganisationDto }[]): any {
    if (!organisations || !organisations.length) {
      return organisations;
    }

    return organisations.sort((a, b) => {
      return a.value.name.localeCompare(b.value.name);
    });
  }
}
